import eventBus from '@refapp/eventbus-js';

export const handleWriteReviewButtonClick = ({ $cookies, productItemId, buttonText }) => {
  eventBus.emit('WriteReviewTags', buttonText);

  const cookieId = 'reviewSubmit' + productItemId;
  const cookieValue = $cookies.get(cookieId);

  if (cookieValue === null) {
    return eventBus.emit('show-write-review');
  }

  if (cookieValue === 'success') {
    return eventBus.emit('review-already-submitted');
  }

  eventBus.emit('show-review-warning');
};
